import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'opt-loader',
  templateUrl: './opt-loader.component.html',
  styleUrls: ['./opt-loader.component.scss']
})
export class OptLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
